$.urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null) {
       return null;
    }
    return decodeURI(results[1]) || 0;
}

$(document).ready(function(){
  var metalColor = null;  // $.urlParam("metal");
  var pageURL = window.location.href;
  if(pageURL.indexOf("/collections/") != -1){
    if(pageURL.indexOf("white-gold") != -1){
      metalColor = "white";
    }
    if(pageURL.indexOf("yellow-gold") != -1){
      metalColor = "yellow";
    }
    if(pageURL.indexOf("rose-gold") != -1){
      metalColor = "rose";
    }
    if(pageURL.indexOf("platinum") != -1){
      metalColor = "platinum";
    }
    
  }
    
  if(metalColor != null && $("ul#product-grid li").length){
    console.log(metalColor);
    $("ul#product-grid li").each(function(){
      var gridObj = $(this);
      if($(this).find(".card__colors color-swatch").length){
        $(this).find(".card__colors color-swatch").each(function(){
          if($(this).attr("title").toLowerCase().indexOf(metalColor) != -1){
            var metalImage = $(this).attr("data-src");
            console.log(metalImage)
            gridObj.find(".media--image-contain img:eq(0)").attr("src", metalImage);
            gridObj.find(".media--image-contain img:eq(0)").attr("srcset", metalImage);
          }
        });
      }
    });
  }
});
